'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var envType = {
  TEST: 'TEST',
  PROD: 'PROD'
};

exports.default = envType;
//# sourceMappingURL=envType.js.map